import { isMobileUserAgent } from "./isMobileUserAgent";

const DESKTOP_BASE = "/dashboard";
const MOBILE_BASE = "/m/dashboard";

/** Trailing-slash-insensitive path comparison (e.g. `/dashboard` vs `/dashboard/`). */
export function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export function isDashboardAreaPath(pathname: string): boolean {
  const p = normalizePathname(pathname);
  return (
    p === DESKTOP_BASE ||
    p.startsWith(`${DESKTOP_BASE}/`) ||
    p === MOBILE_BASE ||
    p.startsWith(`${MOBILE_BASE}/`)
  );
}

export function isDashboardLoginPath(pathname: string): boolean {
  const p = normalizePathname(pathname);
  return p === `${DESKTOP_BASE}/login` || p === `${MOBILE_BASE}/login`;
}

export function getDashboardOverviewPath(): string {
  return isMobileUserAgent() ? `${MOBILE_BASE}/overview` : DESKTOP_BASE;
}

export function getDashboardLoginPath(): string {
  return isMobileUserAgent() ? `${MOBILE_BASE}/login` : `${DESKTOP_BASE}/login`;
}

export function getDashboardCalendarPath(): string {
  return isMobileUserAgent() ? `${MOBILE_BASE}/calendar` : `${DESKTOP_BASE}/calendar`;
}

export function getDashboardUsagePath(): string {
  return isMobileUserAgent() ? `${MOBILE_BASE}/usage` : `${DESKTOP_BASE}/usage`;
}

export function getDashboardBillingPath(): string {
  return isMobileUserAgent() ? `${MOBILE_BASE}/billing` : `${DESKTOP_BASE}/billing`;
}

/**
 * When mobile UA and URL uses desktop `/dashboard` family, return canonical `/m/dashboard/...`.
 */
export function toMobileDashboardPath(pathname: string): string | null {
  if (!isMobileUserAgent()) {
    return null;
  }
  const p = normalizePathname(pathname);
  if (p === MOBILE_BASE || p.startsWith(`${MOBILE_BASE}/`)) {
    return null;
  }
  if (p === DESKTOP_BASE) {
    return `${MOBILE_BASE}/overview`;
  }
  if (!p.startsWith(`${DESKTOP_BASE}/`)) {
    return null;
  }
  const rest = p.slice(`${DESKTOP_BASE}/`.length);
  if (!rest) {
    return `${MOBILE_BASE}/overview`;
  }
  return `${MOBILE_BASE}/${rest}`;
}

/**
 * When desktop UA and URL uses `/m/dashboard`, return canonical `/dashboard/...`.
 */
export function toDesktopDashboardPath(pathname: string): string | null {
  if (isMobileUserAgent()) {
    return null;
  }
  const p = normalizePathname(pathname);
  if (p === DESKTOP_BASE || p.startsWith(`${DESKTOP_BASE}/`)) {
    return null;
  }
  if (p === MOBILE_BASE) {
    return DESKTOP_BASE;
  }
  if (!p.startsWith(`${MOBILE_BASE}/`)) {
    return null;
  }
  const rest = p.slice(`${MOBILE_BASE}/`.length);
  if (rest === "overview") {
    return DESKTOP_BASE;
  }
  if (!rest) {
    return DESKTOP_BASE;
  }
  return `${DESKTOP_BASE}/${rest}`;
}
